import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

import HotelSearchPrefsForm from './HotelSearchPrefsForm';

class HotelSearchPrefsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
     changesDitect:false,
     confirmationModel:false
    };
  }
  addchange=()=>{
    this.setState({
      changesDitect:true
    })
  }
  confimationMethod=()=>{
    this.setState({
      confirmationModel:true
    })
  }
  afterSave=()=>{
    let eventId=[]
    this.props.tours.filter((item)=>{
      if(item.id == this.props.eventId ){
        item.related_group_events.map((data)=>{
          eventId.push(data.id)
        })
      }
    })
    this.setState({
      changesDitect:false
    })
    for(let i=0;i<eventId.length;i++){
      this.props.searchHotels(eventId[i])
    }
  }
  closeConfimation=()=>{
    this.setState({
      confirmationModel:false
    })
  }
  closePreference=()=>{
    this.setState({
      confirmationModel:false
    })
    this.props.onClose
  }
  render() {
    const groups = this.props.groups;

    const searchPrefs = groups.map(group => (
      <div key={group.id} className="group">
        <h4 className="spacing">{group.name}</h4>
        <HotelSearchPrefsForm
          id={group.id}
          prefs={group.hotel_prefs}
          brandList={this.props.brandList}
          brandGroups={this.props.brandGroups}
          savePreferences={this.props.savePreferences}
          onClose={this.props.onClose}
          addchange={this.addchange}
          afterSave={this.afterSave}
        />
      </div>
    ));
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.state.changesDitect?this.confimationMethod:this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Hotel Search Preferences</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="bid-panel-big" id="searchPreferPopup">
              <div className="group-info">
                <h4 className="search-prefer-instruction-header">Find the Right Hotel!</h4>
                <p className="search-prefer-instruction-text">Hotel Searches are centered on the location of your event venue per city. You can skip this step and you will see all hotels starting closest to your venue.</p>
                <p className="search-prefer-instruction-text">
                  To narrow down your search and help you filter out things you don’t want to see, use the options below to set search preferences. You can change them at any time in the Select Hotels process and also add hotels that are shown in your list.
                </p>
                {searchPrefs}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer />
        </Modal>

        {this.state.confirmationModel &&(
          <Modal bsSize="large" show={this.state.confirmationModel} onHide={this.closeConfimation}>
          <Modal.Header closeButton>
            <Modal.Title>confimation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="bid-panel" >
              <p>You have not saved your preferences yet.  Do you want to save before closing the window?</p>
              <div>
                <Button bsStyle="success" style={{ width:'9%'}} onClick={this.closeConfimation}>
                  Yes
                </Button>
                <Button bsStyle="success"  style={{ marginLeft:'12px',width:'9%' }} onClick={()=>(this.props.onClose())}>
                  No
                </Button>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer />
        </Modal>

        )
        }
      </div>
    );
  }
}

HotelSearchPrefsModal.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  brandList: PropTypes.arrayOf(PropTypes.object).isRequired,
  brandGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  show: PropTypes.bool.isRequired,
  savePreferences: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default HotelSearchPrefsModal;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelSearchPrefsModal.js